import { BoxProps, Grid, useTheme } from '@wegroup/design-system';
import React from 'react';
import useMoveHelpButton from '../../../../../../../common/src/hooks/support-chat/useMoveHelpButton';
import useMoveHubspotBubble from '../../../../../../../common/src/hooks/support-chat/useMoveHubspotBubble';
import useElementBounds from '../../../../../../../common/src/hooks/useElementBounds';

interface Props {
  isHovered?: boolean;
}

const CompanyScanBottomBarWrapper: React.FC<
  React.PropsWithChildren<Props & BoxProps>
> = ({ isHovered, children, ...props }) => {
  const { space } = useTheme();
  const spacing4 = Number(space[4].replace('px', ''));

  const { setRef, height } = useElementBounds();
  useMoveHubspotBubble(height);
  useMoveHelpButton(height + spacing4, spacing4);

  return (
    <Grid
      minH="72px"
      bg={isHovered ? 'gray.ultraLight' : 'white'}
      w="100%"
      p="4"
      borderTop="solid 1px"
      borderColor="gray.50"
      alignItems="center"
      gridTemplateColumns={{ base: 'repeat(2, 1fr)', laptop: 'auto 1fr auto' }}
      gap="4"
      ref={setRef}
      pos="relative"
      {...props}
    >
      {children}
    </Grid>
  );
};

export default CompanyScanBottomBarWrapper;
